angular.module('unergie.main')
.controller('potModalCtrl', ($scope, $uibModalInstance, DataAccess, AlertManager, AdminComments, MetaWatcher, ErrorCatcher, account, balance) => {
    $scope.account = account
    $scope.potCredit = {
        id_account: $scope.account.id,
        transaction_type: 14,
        month: moment().format('MM'),
        year: moment().format('YYYY'),
    }

    $scope.ok = () => {
        if (isFinite(parseFloat($scope.potCredit.amount))) {
            $scope.givingPot = true
            return DataAccess.addCreditToPot($scope.potCredit).$promise.then((data) => {
                AlertManager.success(`Montant de ${$scope.potCredit.amount} € crédité`)
                const comment = `<b>AUTOMATIQUE</b> : don exceptionnel de cagnotte : <b>${$scope.potCredit.amount}</b> €, raison : <b>${$scope.potCredit.tx_reference}</b>`
                AdminComments.addComment({ object: $scope.account.customer_id, comment }).$promise.catch(ErrorCatcher)
                MetaWatcher.notif('POT_CHANGED', { id: $scope.account.id })
                $uibModalInstance.close()
            })
            .catch(ErrorCatcher)
            .finally(() => {
                $scope.givingPot = false
            })
        }
        AlertManager.error('Montant incorrect')
    }

    $scope.canGive = () => {
        return $scope.potCredit.amount && !_.isNaN($scope.potCredit.amount) && $scope.potCredit.tx_reference &&
            balance && !_.isNaN(balance.real) && ($scope.potCredit.amount + balance.real) >= 0
    }

    $scope.cancel = () => $uibModalInstance.dismiss('cancel')
})
